import { RecordOf } from '@opengov/compose-app/immutable';
export var FilterOperators;

(function (FilterOperators) {
  FilterOperators["Begin"] = "beginsWith";
  FilterOperators["Blank"] = "isBlank";
  FilterOperators["Contain"] = "contains";
  FilterOperators["End"] = "endsWith";
  FilterOperators["Equal"] = "equal";
  FilterOperators["Greater"] = "greaterThanOrEqual";
  FilterOperators["Lesser"] = "lessThanOrEqual";
  FilterOperators["NotBlank"] = "isNotBlank";
  FilterOperators["NotContain"] = "doesNotContain";
  FilterOperators["NotEqual"] = "notEqual";
})(FilterOperators || (FilterOperators = {}));

export var filterOptions = [// please preserve the ordering if these array items
{
  id: FilterOperators.Equal,
  label: 'Equals',
  icon: 'operator-equal'
}, {
  id: FilterOperators.NotEqual,
  label: 'Does not equal',
  icon: 'operator-notequal'
}, {
  id: FilterOperators.Contain,
  label: 'Contains',
  icon: 'operator-contains'
}, {
  id: FilterOperators.NotContain,
  label: 'Does not contain',
  icon: 'operator-doesnotcontain'
}, {
  id: FilterOperators.Blank,
  label: 'Is empty',
  icon: 'operator-isnotfilled'
}, {
  id: FilterOperators.NotBlank,
  label: 'Is not empty',
  icon: 'operator-isfilled'
}, {
  id: FilterOperators.Begin,
  label: 'Starts with',
  icon: 'arrow-right-small'
}, {
  id: FilterOperators.End,
  label: 'Ends with',
  icon: 'arrow-left-small'
}, {
  id: FilterOperators.Greater,
  label: 'Greater than or equal to',
  icon: 'operator-greaterthanorequal'
}, {
  id: FilterOperators.Lesser,
  label: 'Lesser than or equal to',
  icon: 'operator-lessthanorequal'
}];
export var textFilterOptions = filterOptions.filter(function (option) {
  return [FilterOperators.Contain, FilterOperators.Blank, FilterOperators.End, FilterOperators.NotContain, FilterOperators.NotBlank, FilterOperators.Begin, FilterOperators.Equal, FilterOperators.NotEqual].includes(option.id);
});
export var getIconForOperator = function getIconForOperator(operator) {
  var option = filterOptions.find(function (o) {
    return o.id === operator;
  });
  return option ? option.icon : 'status-error';
};
export var getLabelForOperator = function getLabelForOperator(operator) {
  var option = filterOptions.find(function (o) {
    return o.id === operator;
  });
  return option ? option.label : '';
};
export var BooleanOperators;

(function (BooleanOperators) {
  BooleanOperators["And"] = "and";
  BooleanOperators["Or"] = "or";
})(BooleanOperators || (BooleanOperators = {}));

export var ColumnFilterRecord = RecordOf({
  operator: null,
  value: null,
  columnName: null
});